/* tslint:disable */
import { observer } from 'mobx-react'
import * as React from 'react'
import styled from 'styled-components'

import { withRouter } from 'react-router'
import Swal from 'sweetalert2'
import CheckKidsValidity from './CheckKidsValidity'
import { intakeMetrics } from '../organisms/Intakes/intakeMetrics/calcIntakeMetrics'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en';

const MobileMenu = withRouter(observer(({ intake, history, store }) => {
  const {
    section1Started,
    section2Started,
    section3Started,
    section4Started,
    furthestWebinfoPage,
  } = intakeMetrics(intake)

  console.log(section4Started)
  console.log(section3Started)
  console.log(section2Started)
  console.log(section1Started)

  if (!store.isMenuShown) {
    return null
  }

  let furthestnum = []

  const isWebInfo = store.isWebInfo || isWebInfo

  const startLink = isWebInfo ? '/contents/webinfo-01' : (section1Started ? '/contents/01' : '/welcome')

  if(furthestWebinfoPage){
    furthestnum = furthestWebinfoPage.split('/contents/webinfo-');
  }

  const section1Webinfo = (furthestnum && furthestnum.length > 1 && parseInt(furthestnum[1]) > 0) ? true : false;
  const section2Webinfo = (furthestnum && furthestnum.length > 1 && parseInt(furthestnum[1]) > 5) ? true : false;
  const section3Webinfo = (furthestnum && furthestnum.length > 1 && parseInt(furthestnum[1]) > 11) ? true : false;
  const section4Webinfo = (furthestnum && furthestnum.length > 1 && parseInt(furthestnum[1]) > 17) ? true : false;

  return (
    <div
      style={{
        position: 'fixed',
        overflow: 'scroll',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#253541',
        zIndex: 100
      }}>
      <MobileCloseBtn
        onClick={() => store.hideMenu()}
      />
      <div style={{ paddingLeft: 30 }}>
        <BigBtn
          isVisible
          history={history}
          link={startLink}
          canClick
          store={store}
          isSelected={store.isWebTipsSelected}
          isBlue
        >{isWebInfo ? 'WebInfo' : (lang === 'es' ? 'L-WebTIPS' : 'WebTIPS')}</BigBtn>
        <div style={{ paddingLeft: 20 }}>

          <SmallBtn
            isVisible={!intake || section1Started || isWebInfo}
            canClick={section1Started || isWebInfo}
            isSelected={store.isInfoSelected}
            store={store}
            history={history}
            link={startLink}
            isBlue>{lang === 'es' ? 'Información' : 'Info'}</SmallBtn>
          <div style={{ paddingLeft: 30 }}>
            <SmallBtn2
              isVisible={!intake || section1Started || isWebInfo}
              history={history}
              store={store}
              canClick={section1Started || isWebInfo}
              link={store.linkSection1}
              isSelected={store.isInfoSection1Selected}
              isBlue>{lang === 'es' ? 'Casa antes de la cirugía' : 'Home before surgery'}</SmallBtn2>
            <SmallBtn2
              isVisible={!intake || section1Started || isWebInfo}
              history={history}
              canClick={section2Started || isWebInfo}
              store={store}
              link={store.linkSection2}
              isSelected={store.isInfoSection2Selected}
              isBlue>{lang === 'es' ? 'Cirugía' : 'Surgery'}</SmallBtn2>
            <SmallBtn2
              isVisible={!intake || section1Started || isWebInfo}
              history={history}
              store={store}
              canClick={section3Started || isWebInfo}
              link={store.linkSection3}
              isSelected={store.isInfoSection3Selected}
              isBlue>{lang === 'es' ? 'Cuarto de recuperación' : 'Recovery Room'}</SmallBtn2>
            <SmallBtn2
              isVisible={!intake || section1Started || isWebInfo}
              history={history}
              store={store}
              canClick={section4Started || isWebInfo}
              link={store.linkSection4}
              isSelected={store.isInfoSection4Selected}
              isBlue>{lang === 'es' ? 'Casa después de la cirugía' : 'Home after surgery'}</SmallBtn2>
          </div>
          {
            store.isWebInfo ? <div />
              : [
                <SmallBtn
                  isVisible={intake && !section1Started}
                  canClick
                  history={history}
                  link='/welcome'
                  store={store}
                  isSelected={store.isWelcomeSelected}
                  isBlue>{lang === 'es' ? 'Informacion' : 'Welcome'}</SmallBtn>,
                <SmallBtn
                  isVisible
                  canClick
                  history={history}
                  link='/contents/help'
                  store={store}
                  isSelected={store.isHelpSelected}
                  isBlue>{lang === 'es' ? 'Ayuda' : 'Help'}</SmallBtn>,
                <SmallBtn
                  isVisible
                  canClick
                  history={history}
                  link='/contents/63'
                  store={store}
                  isSelected={store.isPrintSelected}
                  isBlue>{lang === 'es' ? 'Imprimir' : 'Print'}</SmallBtn>,
                <SmallBtn
                  isVisible
                  canClick
                  history={history}
                  link='/contents/who-we-are'
                  isSelected={store.isAboutSelected}
                  store={store}
                  isBlue>{lang === 'es' ? 'Sobre L-WebTIPS' : 'About'}</SmallBtn>
              ]
          }
        </div>
        {!store.isWebInfo
          ? [
            <BigBtn
              isVisible
              history={history}
              store={store}
              link='/kids'
              canClick
              isSelected={store.isKidsSelected}
            >{lang === 'es' ? 'Espacio para niños' : 'Kids Space'}</BigBtn>,
            <div style={{ paddingLeft: 20 }}>
              <SmallBtn
                isVisible
                canClick
                store={store}
                history={history}
                link='/kids-video'
                isSelected={store.isKidsVideoSelected}
              >{lang === 'es' ? 'Video' : 'Video'}</SmallBtn>
              <SmallBtn
                isVisible
                canClick
                store={store}
                history={history}
                link='/kids-tour'
                isSelected={store.isKidsTourSelected}
              >{lang === 'es' ? 'Recorrido' : 'Tour'}</SmallBtn>
              <SmallBtn
                isVisible
                canClick
                store={store}
                history={history}
                link='/kids-games'
                isSelected={store.isKidsGamesSelected}
              >{lang === 'es' ? 'Juegos' : 'Games'}</SmallBtn>
              <SmallBtn
                isVisible
                canClick
                store={store}
                history={history}
                link='/kids-activities'
                isSelected={store.isKidsActivitiesSelected}
              >{lang === 'es' ? 'Actividades' : 'Activities'}</SmallBtn>
            </div>
          ]
          : <div />
        }
      </div>
    </div>
  )
}))

const SmallBtnStyled = styled.button`
    background-image: ${props => {
    if (props.isSelected) {
      return 'linear-gradient(180deg, #FF9921 0%, #F58238 100%);'
    } else if (props.isBlue) {
      return 'linear-gradient(225deg,#3D83F3 0%,#2D6ED5 100%);'
    } else {
      return 'linear-gradient(225deg, #ED4A96 0%, #B12867 100%);'
    }
  }}
    border-radius: 25px;
    display: block;
    margin-bottom: 10px;
    height: 40px;
    line-height: 40px;
    padding-left: 25px;
    padding-right: 25px;
    border: none;
    color: white;
    font-size: 22px;
    font-weight: 800;
    cursor: pointer;
`

const SmallBtn2Styled = styled.button`
    border-radius: 25px;
    display: block;
    margin-bottom: 10px;
    line-height: 40px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 22px;
    font-weight: 800;
    cursor: pointer;
    border: ${props => {
    if (props.isSelected) {
      return '1px solid #FA8D2D;'
    } else {
      return '1px solid #3D83F2;'
    }
  }}
    border-radius: 25px;
    font-family: Nunito-Black;
    font-size: 18px;
    color: ${props => {
    if (props.isSelected) {
      return ' #FA8D2D;'
    } else {
      return '#3D83F2;'
    }
  }}
    background: transparent;
    line-height: 40px;

`

const BtnConverter = (MyClass) => observer((props) => {
  let onClick = async () => {
    // if (!props.isSelected) {
    if (!props.link.includes('kids') && window.location.href.includes('kids')) {
      const response = await Swal.fire({
        title: `<strong>${lang === 'es' ? '¿Ir al sitio de adultos?' : 'Go To Grow Ups Site?'}</strong>`,
        html:
            `${lang === 'es' ? 'Esto lo llevará de regreso al sitio de los Padres. ¿Estás seguro de que quieres irte?' : 'This will take you back to the Parent\'s site. Are you sure you want to leave?'}`,
        showCancelButton: true,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText:
            'No',
        cancelButtonText:
          `${lang === 'es' ? 'Si' : 'Yes'}`,
      })

      if (response.dismiss === Swal.DismissReason.cancel) {
        props.store.goLink(props.history, 'welcome-back')
      }
    } else if (props.link.includes('kids') && !window.location.href.includes('kids')) {
      const section4ReviewCompleted = await CheckKidsValidity()
      if (section4ReviewCompleted) {
        props.store.goLink(props.history, props.link)
      } else {
        props.store.goLink(props.history, '/kids-forbidden')
      }
    } else if (props.link.includes('kids') && window.location.href.includes('/kids-forbidden')) {
      const section4ReviewCompleted = await CheckKidsValidity()
      if (section4ReviewCompleted) {
        props.store.goLink(props.history, props.link)
      } else {
        props.store.goLink(props.history, '/kids-forbidden')
      }
    } else {
      props.store.goLink(props.history, props.link)
    }
    // }
  }
  if (props.canClick) {
    if (!props.isVisible) {
      return (
        <MyClass onClick={onClick} {...props} style={{ display: 'none' }} />
      )
    } else {
      return (
        <MyClass onClick={onClick} {...props} />
      )
    }
  } else {
    if (!props.isVisible) {
      return (
        <MyClass {...props} style={{ opacity: 0.5, display: 'none' }} />
      )
    } else {
      return (
        <MyClass {...props} style={{ opacity: 0.5 }} />
      )
    }
  }
})

const BigBtnStyled = styled.button`
    background-image: ${props => {
    if (props.isSelected) {
      return 'linear-gradient(180deg, #FF9921 0%, #F58238 100%);'
    } else if (props.isBlue) {
      return 'linear-gradient(225deg,#3D83F3 0%,#2D6ED5 100%);'
    } else {
      return 'linear-gradient(225deg, #ED4A96 0%, #B12867 100%);'
    }
  }}
    display; block;
    border-radius: 25px;
    margin-bottom: 10px;
    height: 50px;
    line-height: 50px;
    padding-left: 25px;
    padding-right: 25px;
    border: none;
    color: white;
    font-size: 26px;
    font-weight: 800;
    cursor: pointer;
`

const MobileCloseBtn = styled.div`
  cursor: pointter;
  margin-top: 30px;
  margin-left: 30px;
  margin-bottom: 22px;
  height: 26px;
  width: 27px;
  background: url(https://s3-us-west-1.amazonaws.com/uci-images/images/mobileClose.svg);
  background-repeat: no-repeat;
`

const BigBtn = BtnConverter(BigBtnStyled)
const SmallBtn = BtnConverter(SmallBtnStyled)
const SmallBtn2 = BtnConverter(SmallBtn2Styled)

export default MobileMenu



// WEBPACK FOOTER //
// ./src/atoms/MobileMenu.js